import React, { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../Univ.js";

function PharmApprovalLogList() {

  const [rows, setRows] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    axios.get(`${baseUrl}pharm-approval-log/`)
      .then(res => {

        const data = res.data.map(item => ({
          id: item.id,
          module: item.module,
          record_id: item.record_id,
          approval_level: item.approval_level,
          approved_by: item.approved_by,
          status: item.status,
          remarks: item.remarks,
          add_date: item.add_date,
          add_time: item.add_time,
        }));

        setRows(data);

      })
      .catch(err => console.log(err));
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    { field: "module", headerName: "Module", width: 130 },

    { field: "record_id", headerName: "Record ID", width: 120 },

    { field: "approval_level", headerName: "Level", width: 100 },

    { field: "approved_by", headerName: "Approved By", width: 160 },

    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => (
        <span
          className={
            params.value === "Approved"
              ? "badge bg-success"
              : params.value === "Rejected"
              ? "badge bg-danger"
              : "badge bg-warning text-dark"
          }
        >
          {params.value}
        </span>
      )
    },

    { field: "remarks", headerName: "Remarks", width: 200 },

    { field: "add_date", headerName: "Date", width: 120 },

    { field: "add_time", headerName: "Time", width: 120 },
    {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => (
                <div className="d-flex gap-2">
                    <Link
                        to={`/pharm-approve-log-view/${params.row.id}`}
                        className="btn btn-success btn-sm"
                    >
                        View
                    </Link>
                </div>
            )
        }
  ];

  return (
    <section className="container mt-4">

      <h3 className="text-center bg-light p-2">
        Approval Logs
      </h3>

      <div style={{ height: 600, width: "100%" }} className="mt-3">

        <DataGrid
         sx={{
                boxShadow: 4,
                border: 4,
                borderColor: 'primary.light',
                '& .MuiDataGrid-cell:hover': {
                  color: 'primary.main',
                },
              }}
          autoHeight
          rows={rows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 25, 50]}
          initialState={{
            sorting: {
              sortModel: [{ field: "id", sort: "desc" }],
            },
          }}
        />

      </div>

    </section>
  );
}

export default PharmApprovalLogList;